import { Card, Col, DatePicker, Form, Row } from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';
import { CustomSelect } from './form/CustomSelect';
import ShowInfoPartnerButton from './ShowInfoPartnerButton';

export const fields = {
  plan: {
    PARTNER_ID: 'part_id',
    PARTNER_NAME: 'part_name',
    VEHICLE_PARTNER_ID: 'vhc_part_id',
    VEHICLE_PARTNER_NAME: 'vhc_part_name',
    START_DATE: 'book_rent_date',
    END_DATE: 'book_retun_date',
  },
  actual: {
    PARTNER_ID: 'part_id_actual',
    PARTNER_NAME: 'part_name_actual',
    VEHICLE_PARTNER_ID: 'vhc_part_id_actual',
    VEHICLE_PARTNER_NAME: 'vhc_part_name_actual',
    START_DATE: 'book_rental_date_actual',
    END_DATE: 'book_return_date_actual',
  },
};

const unlistedPartner = { part_id: 0, part_name: '-- Đối tác ngoài --' };

export default function FormBookingUnsureGroup(props) {
  const {
    type,
    booking,
    form,
    onPartnerChange,
    selectedCity,
    selectedType,
  } = props;

  const isEditMode = !!booking;

  const fieldNames = fields[type];

  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [partners, setPartners] = useState([]);
  const [partner, setPartner] = useState();

  let partnerOptions = [...partners];
  if (type === 'actual') {
    partnerOptions.unshift(unlistedPartner);
  }

  async function fetchVehicleOptions(selectedPartnerId) {
    const vehicles = await VehiclePartnerApi.getVehicleByOption({
      part_id: selectedPartnerId,
    });

    setVehicleOptions(vehicles);
  }

  useEffect(() => {
    fetchPartnerOptions(booking.city_id, booking.vhc_type_id);
  }, [selectedCity, selectedType]);

  async function fetchPartnerOptions(city, type) {
    const selectedCity = props.selectedCity || city;
    const selectedType = props.selectedType || type;

    if (!selectedCity || !selectedType) {
      setPartners([]);
      return;
    }

    const partners = await PartnerApi.getPartnerByOptions({
      vhc_type_id: selectedType,
      city_id: selectedCity,
    });

    const partner = partners.find(
      (partner) => partner.part_id === booking[fieldNames.PARTNER_ID]
    );

    setPartners(partners);
    setPartner(partner);
  }

  async function onVehicleChange(selectedVehicleId) {
    const selectedVehicle = vehicleOptions.find(
      (v) => v.vhc_part_id === selectedVehicleId
    );
    form.setFieldsValue({
      [fieldNames.VEHICLE_PARTNER_NAME]: get(
        selectedVehicle,
        'vhc_part_name',
        null
      ),
    });
  }
  useEffect(() => {
    if (booking) {
      const partnerId = booking[fieldNames.PARTNER_ID];

      if (partnerId) {
        fetchVehicleOptions(partnerId);
      }
    }
  }, []);

  async function onChange(partId) {
    const partner = partners.find((partner) => partner.part_id === partId);
    setPartner(partner);
    onPartnerChange(partner);
    if (partner?.part_id !== 0) {
      fetchVehicleOptions(partner?.part_id);
    }
    if (partner?.part_id === undefined || partner?.part_id === 0) {
      setPartner(null);
      return;
    }
  }

  const shouldDisableInput = !!booking && type === 'plan';

  return (
    <Card title={type === 'plan' ? 'Dự kiến' : 'Thực tế'} className="mb-3">
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            name={fieldNames.START_DATE}
            label="Thời gian nhận xe"
            rules={[{ required: type === 'plan' }]}
          >
            <DatePicker
              showTime={{
                format: 'HH:mm',
                minuteStep: 10,
                defaultValue: isEditMode
                  ? undefined
                  : moment().set('hour', 7).startOf('hour'),
              }}
              disabled={shouldDisableInput}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={fieldNames.END_DATE}
            label="Thời gian trả xe"
            rules={[{ required: type === 'plan' }]}
          >
            <DatePicker
              showTime={{
                format: 'HH:mm',
                minuteStep: 10,
                defaultValue: isEditMode
                  ? undefined
                  : moment().set('hour', 21).startOf('hour'),
              }}
              disabled={shouldDisableInput}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            extra="Chọn Thành phố và Loại xe trước"
            name={fieldNames.PARTNER_ID}
            label={
              <>
                Đối tác {partner && <ShowInfoPartnerButton partner={partner} />}
              </>
            }
          >
            <CustomSelect
              dataSource={partnerOptions}
              labelField="part_name"
              valueField="part_id"
              relatedDataField="part_name"
              relatedFormField={fieldNames.PARTNER_NAME}
              form={form}
              onChange={(value) => {
                onChange(value);
              }}
              disabled={shouldDisableInput}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            extra="Chọn Đối tác trước"
            name={fieldNames.VEHICLE_PARTNER_ID}
            label="Xe"
          >
            <CustomSelect
              dataSource={vehicleOptions}
              labelField="vhc_part_name"
              valueField="vhc_part_id"
              relatedDataField="vhc_part_name"
              relatedFormField={fieldNames.VEHICLE_PARTNER_NAME}
              form={form}
              onChange={onVehicleChange}
              disabled={shouldDisableInput || !partner}
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}
